export default __webpack_public_path__ + "static/media/ecologistic.69f47689.png";